import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Button from "src/components/Button";
import { getCompanyAtsJob } from "src/network/company_ats";
import Layout from "src/router/AuthenticatedRouter/Layout";
import { AtsJob } from "src/types/merge_ats";
import LoaderLayout from "src/router/AuthenticatedRouter/Layout/LoaderLayout";
import StatusTag from "../../Components/StatusTag";
import Tabs from "src/components/Tabs";
import Description from "./tabs/Description";
import { ReactComponent as Arrow } from "src/assets/svg/↖.svg";
import Candidates from "./tabs/Candidates";
import ImportJobModal from "../../Components/ImportJobModal";

type Tabs = "Job Description" | "All Candidates";
const tabs: Tabs[] = ["Job Description", "All Candidates"];

const AtsJobDetailPage = () => {
  const [importing, setImporting] = useState(false);
  const [job, setJob] = useState<AtsJob>();
  const { id } = useParams();

  const fetchJob = async () => {
    if (!id) return;
    const job = await getCompanyAtsJob({ id });
    setJob(job);
  };

  useEffect(() => {
    fetchJob();
  }, [id]);

  if (!job) return <LoaderLayout />;

  return (
    <Layout
      back={"/ats"}
      className="!overflow-hidden flex flex-col"
      title={
        <div className="flex items-center gap-6">
          <p>{job.name}</p>
          <StatusTag job={job} />
        </div>
      }
      rightChildren={
        <Button
          className="flex items-center gap-[10px]"
          onClick={() => setImporting(true)}
          shapeVariant={2}
          variant="white_blue"
        >
          <Arrow className="w-6 h-6" /> Import Job
        </Button>
      }
    >
      <Tabs
        withSearchParam
        tabs={tabs}
        contents={[<Description job={job} />, <Candidates job={job} />]}
      />

      {/* Modals */}
      <ImportJobModal job={job} open={importing} onClose={() => setImporting(false)} />
    </Layout>
  );
};

export default AtsJobDetailPage;
